@search-sidebar-percentage-width: 35%;
@search-sidebar-max-width: 500px;
@search-sidebar-min-breakpoint: 900px; // Used to pointpoint map objects relative to the sidebar
@search-sidebar-max-breakpoint: 1450px; // Used to pointpoint map objects relative to the sidebar
@search-sidebar-min-width: 360px;
@search-controls-gap-mobile: 6px;
@search-message-width: 300px;
@search-sidebar-toggle-height: 46px;
